var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[(_vm.orderList.length)?_c('div',{staticClass:"orders-list"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title is-3 has-text-grey pl-2 pt-5"},[_vm._v(" BESTELLVERLAUF ")])]),_vm._l((_vm.orderList),function(item,index){return _c('div',{key:index},[_c('OrderListElement',{attrs:{"item":item}})],1)})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }